export default __webpack_public_path__ + "static/media/mt_ln_4.4655936e.png";